import {
  REQUEST_SEARCH_CLAIMS,
  SET_SEARCH_CLAIMS,
  RESET_SEARCH_CLAIMS_STORE,
  SET_LOSS_DATE,
  REQUEST_SEARCH_PANDING_CLAIMS,
  SEND_EXISTING_CLAIMS_AND_DOCUMENT,
  SET_SELECTED_CLAIM,
  REQUEST_SUPPORT_DOCUMENTS,
  SET_FOUND_CLAIMS,
} from 'containers/IdentificationPage/constants';

export interface ISearchQuery {
  lossDate: string | null;
  registrationNumber: string | null;
  policyNumber: string | null;
}

export interface ISupportDocument {
  type: string;
  policyNumber: string;
}

export const requestSearchClaims = (searchQuery: any) => {
  return {
    type: REQUEST_SEARCH_CLAIMS,
    searchQuery,
  };
};

export const setSearchClaims = (searchClaims: any) => ({
  type: SET_SEARCH_CLAIMS,
  searchClaims,
});

export const setFoundClaims = (foundClaims: any) => ({
  type: SET_FOUND_CLAIMS,
  foundClaims,
});

export const resetSearchClaimsStore = () => ({
  type: RESET_SEARCH_CLAIMS_STORE,
});

export const setLossDate = (lossDate: Date) => ({
  type: SET_LOSS_DATE,
  lossDate,
});

export const requestFindClaims = (searchQuery: ISearchQuery) => {
  return { type: REQUEST_SEARCH_PANDING_CLAIMS, searchQuery };
};

export const setSelectedClaim = (selectedClaim: number) => ({
  type: SET_SELECTED_CLAIM,
  selectedClaim,
});
export const sendExistingClaimAndDocument = (
  payload: any,
  callback: Function,
) => ({
  type: SEND_EXISTING_CLAIMS_AND_DOCUMENT,
  callback,
  payload: payload,
});

export const requestSupportDocuments = (supportDocument: ISupportDocument) => {
  return { type: REQUEST_SUPPORT_DOCUMENTS, supportDocument };
};
